import { Component, OnInit} from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { DescuentoEditComponent } from '../descuento-edit/descuento-edit.component';


@Component({
  selector: 'app-descuento',
  templateUrl: './descuento.component.html',
  styleUrls: ['./descuento.component.css'],
  providers:[
    { provide: MatDialogRef,useValue: {} }
  ]
})
export class DescuentoComponent implements OnInit {
  errMsg:any;
  loading:boolean=false;
  descs:any=[];

  constructor(private dataService: DataService, public dialogRef: MatDialogRef<DescuentoEditComponent>, public dialog: MatDialog) { }

  ngOnInit() {
    this.fnIniciar();
  }

  fnIniciar(){
    this.loading = true;
    this.dataService.getDescuentos(9).subscribe(
                      rows => {   
                              this.descs = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnDescuentosCargados());
  }

  fnDescuentosCargados(){
    //console.log(this.descs);
    this.loading = false
  }

  fnEditar(desc){
    //console.log("Editar: " + desc.id);
    let dialogRef = this.dialog.open(DescuentoEditComponent, {
                                      width: "600px",
                                      data: { 
                                            id:desc.id,
                                            item:desc
                                            }
                                    });
    dialogRef.afterClosed().subscribe(result => {
                                    console.log("Popup cerrado");
                                    this.fnIniciar();
                                    }); 
  }

  fnNuevo(){
    //console.log("Ingresar nuevo item");
    let dialogRef = this.dialog.open(DescuentoEditComponent, {
                                      width: "600px",
                                      data: { 
                                            id:-1,
                                            item:{'desceunto': null,
                                                  'descrip': null,
                                                  'mon_por': '%',
                                                  'valor': null,
                                                  'act':1
                                                 }
                                            }
                                    });
    dialogRef.afterClosed().subscribe(result => {
                                    console.log("Popup cerrado");
                                    this.fnIniciar();
                                    }); 
  }

}
